const form3 = {
  formId3: "new-user-form3",
  formField3: {
    taxpayers: {
      name: "taxpayers",
      label: "Người nộp thuế:",
      type: "text",
      placeholder: "Người nộp thuế",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    taxCode: {
      name: "taxCode",
      label: "Mã số thuế:",
      type: "text",
      placeholder: "Mã số thuế",
      errorMsg: "Vui lòng nhập mã số thuế",
    },
    taxAgentName: {
      name: "taxAgentName",
      label: "Tên đại lý thuế (nếu có):",
      type: "text",
      placeholder: "Đại lý thuế",
      errorMsg: "Vui lòng nhập tên đại lý thuế",
    },
    taxAgentCode: {
      name: "taxAgentCode",
      label: "Mã số thuế:",
      type: "text",
      placeholder: "Mã số thuế",
      errorMsg: "Vui lòng nhập mã số thuế",
    },
    ///
    supportData: {
      name: "supportData",
      label: "Hỗ trợ lấy dữ liệu từ năm trước",
      type: "text",
    },
    enterVoiceover: {
      name: "enterVoiceover",
      label: "Tích chọn để nhập cột thuyết minh",
      type: "text",
    },
  },
};

export default form3;
